import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../../core/authentication/authentication.service'
import { AppMetadataHandler, AppOrganizationSettings } from '../../configs'
import { ThreadsService } from '../../core/utilities/threads.service'

/* Router and Notif for client error */
import { Router, ActivatedRoute, Params } from '@angular/router';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { environment } from 'environments/environment';
import { ApiRequestService, CommonUtilty } from 'app/BaseFramework/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { SessionTimeoutService } from 'app/BaseFramework/core/services/session/session-timeout.service';
import configjson from '../../../../configs/health-nbu-transaction.json'

export interface LoginContext {
  username: string;
  password: string;
  remember?: boolean;
}


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  constructor(
    public authenticationService: AuthenticationService,
    private notificationService: NzNotificationService,
    private activatedRoute: ActivatedRoute,
    public appMetadataHandler: AppMetadataHandler,
    private appOrganizationSettings: AppOrganizationSettings,
    private threadsService: ThreadsService,
    private apiRequestService: ApiRequestService,
    private commonUtilty: CommonUtilty,
    private http: HttpClient,
    public sessionTimeoutService:SessionTimeoutService
  ) {
    this.activatedRoute.queryParams.subscribe(params => {
      let error = params['error'];
      if (error) {
        this.notificationService.create('error', 'Error', error + "<br><b>Please reload the app.</b>");
        /* Type, Title, Message */
        setTimeout(() => {
          //window.location = window.location.pathname + window.location.hash; /* Take off error param */
          //window.location.reload();
        }, 5000);
      }
    });
  };
  organizationMetaData

  ngOnInit() {
    // this.sessionTimeoutService.stop();
    this.authenticationService.logout();
    this.organizationMetaData = this.appOrganizationSettings.getOrganizationMetaData();
    this.getConfigDataAndInitialize()
    this.threadsService.PRELOGINTHREAD().subscribe(o => {
      if (o['status'])
        this.threadsService._successThreadLog('Pre-Login Thread Successful');
      else
        this.threadsService._errorThreadLog('There is some problem in pre-login thread');
    })

    /* Prefetch icons hack. @thinkdj 31jul19 */
    setTimeout(() => { this.prefetch = true }, 500);

    if (!environment.production) {
      // this.login(environment['loginContext'])
      //this.login({ username: "INT1", password: "admin" });
    }
  }

  loginContext: LoginContext = { username: "", password: "" };

  login(context: LoginContext) {
    this.authenticationService.fetchToken(context, this.appMetadataHandler.getEntryPoint());
  }

  prefetch: boolean = false;

  configPath = "/configs/health-nbu-transaction.json"
  configData: any
  getConfigDataAndInitialize() {
    // get configData from Assets
    /*Load json file locally */
    // if (environment.overRideHost) {
    //   this.getJSON().subscribe(response => {
    //     this.configData = this.commonUtilty.deepCopy(response);
    //     this.appMetadataHandler.setCurrency(this.configData.AppConstants.defaultCurrency)
    //   });
    // }else{
      // this.apiRequestService.get(this.configPath, null, true).subscribe(response => {
      //   this.configData = this.commonUtilty.deepCopy(response);
        this.configData = configjson;
        this.appMetadataHandler.setCurrency(this.configData.AppConstants.defaultCurrency)
      // })
    // }
    
    // this.appMetadataHandler.setCurrency("HKD")
  }
  /*Loading config file locally */
  public getJSON(): Observable<any> {
    return this.http.get(this.configPath);
  }


}
